import axiosInstance from "./AxiosConfig";

class SettingApiService {
  async CreateEmailSetting(data, lableData = "") {
    
    let payload = {};
    if (data.typeId === 1) {
      payload = {
        typeId: data.typeId,
        F1: data.Email,
        F2: data.Value,
      };
      return payload;
    } else if (data.typeId === 2) {
      console.log(data.typeId);
      payload = {
        typeId: data.typeId,
        F1: lableData.emailAddress,
        F2: data.emailAddress,
        F3: lableData.Password,
        F4: data.Password,
        F5: lableData.hostName,
        F6: data.hostName,
        F7: lableData.port,
        F8: data.port,
        F9: lableData.enableSSL,
        F10: data.enableSSL,
      };
    } else if (data.typeId === 3) {
      payload = {
        typeId: data.typeId,
        F1: lableData.URL,
        F2: data.URL,
        F3: lableData.QueryString,
        F4: data.QueryString,
        F5: lableData.mobileNoLength,
        F6: data.mobileNoLength,
        F7: lableData.encodeSMS,
        F8: data.encodeSMS,
        F9: lableData.countryCode,
        F10: data.countryCode,
      };
    }

    // URL: "",
    // QueryString: "",
    // mobileNoLength: "",
    // encodeSMS: false,
    // countryCode: "",

    try {
      const response = await axiosInstance.post(`/setting/create`, payload);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async UpdateAllSetting(data, lableData = "", id) {
    
    let payload = {};
    if (data.typeId === 1) {
      payload = {
        typeId: data.typeId,
        F1: data.Email,
        F2: data.Value,
      };
      return payload;
    } else if (data.typeId === 2) {
      console.log(data.typeId);
    } else if (data.typeId === 3) {
      payload = {
        typeId: data.typeId,
        F2: lableData.URL,
        F3: data.URL,
        F4: lableData.QueryString,
        F5: data.QueryString,
        F6: lableData.mobileNoLength,
        F7: data.mobileNoLength,
        F8: lableData.encodeSMS,
        F9: data.encodeSMS,
        F10: lableData.countryCode,
        F11: data.countryCode,
      };
    }
    try {
      const response = await axiosInstance.put(
        `/setting/update/${id}`,
        payload
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async GetSettingById(id) {
    
    try {
      if (id === undefined || id === null || id === "") {
        return;
      }
      const response = await axiosInstance.get(`/setting/getbyid/${id}`);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async GetSettingByType(type) {
    try {
      const response = await axiosInstance.get(`/setting/getbytype/${type}`);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async UpdateByType(type, data) {
    
    try {
      const response = await axiosInstance.put(
        `/setting/updatebytype/${type}`,
        data
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  
}


export default new SettingApiService();
